import { AreaNotification, LayoutContainer } from "@relode/core";
import * as React from "react";

import { OrderReceipt } from "../../../../../shared/components";
import {
    JobOverview,
    Order as JobOrderType,
} from "../../../../../shared/types";

type JobOrderProps = {
    order: JobOrderType;
    overview: JobOverview;
};

export const JobOrder = (props: JobOrderProps) => {
    const { order, overview } = props;

    return (
        <LayoutContainer>
            <AreaNotification areaName="teamPlanWarning" />
            <OrderReceipt
                planName={order.planName}
                totalPositionQuantity={order.quantity}
                employmentGuarantee={order.employmentGuarantee}
                jobId={overview.jobId}
                jobName={overview.jobName}
                jobLocation={overview.location.locationName}
                jobManagerUserId={overview.jobManager.userId}
                jobManagerFullName={overview.jobManager.fullName}
                jobManagerRoleName={overview.jobManager.roleName}
                isFullTimeOrPartTime={overview.jobType.isFullTimeOrPartTime()}
                jobPriorityType={overview.jobPriorityType}
                postingFeeInUSDollars={order.postingFeeInUSDollars}
                successFeePercentage={order.successFeePercentage}
                successFeeInUSDollars={order.successFeeInUSDollars}
                successFeeSavingsInUSDollars={
                    order.successFeeSavingsInUSDollars
                }
                defaultPostingFeeInUSDollars={
                    order.defaultPostingFeeInUSDollars
                }
                marketResearchFeatureType={order.marketResearchFeatureType}
                defaultJobPriorityASuccessFeePercentage={
                    order.defaultJobPriorityASuccessFeePercentage
                }
                defaultJobPriorityBSuccessFeePercentage={
                    order.defaultJobPriorityBSuccessFeePercentage
                }
                defaultJobPriorityCSuccessFeePercentage={
                    order.defaultJobPriorityCSuccessFeePercentage
                }
                defaultJobPriorityDSuccessFeePercentage={
                    order.defaultJobPriorityDSuccessFeePercentage
                }
                estimatedDefaultJobPriorityASuccessFeeInUSDollars={
                    order.estimatedDefaultJobPriorityASuccessFeeInUSDollars
                }
                estimatedDefaultJobPriorityBSuccessFeeInUSDollars={
                    order.estimatedDefaultJobPriorityBSuccessFeeInUSDollars
                }
                estimatedDefaultJobPriorityCSuccessFeeInUSDollars={
                    order.estimatedDefaultJobPriorityCSuccessFeeInUSDollars
                }
                estimatedDefaultJobPriorityDSuccessFeeInUSDollars={
                    order.estimatedDefaultJobPriorityDSuccessFeeInUSDollars
                }
                estimatedDefaultJobPriorityASuccessFeeSavingsInUSDollars={
                    order.estimatedDefaultJobPriorityASuccessFeeSavingsInUSDollars
                }
                estimatedDefaultJobPriorityBSuccessFeeSavingsInUSDollars={
                    order.estimatedDefaultJobPriorityBSuccessFeeSavingsInUSDollars
                }
                estimatedDefaultJobPriorityCSuccessFeeSavingsInUSDollars={
                    order.estimatedDefaultJobPriorityCSuccessFeeSavingsInUSDollars
                }
                estimatedDefaultJobPriorityDSuccessFeeSavingsInUSDollars={
                    order.estimatedDefaultJobPriorityDSuccessFeeSavingsInUSDollars
                }
                billRateInUSDollars={order.billRateInUSDollars}
                estimatedContractBillTotalInUSDollars={
                    order.estimatedContractBillTotalInUSDollars
                }
                estimatedContractBillTotalSavingsInUSDollars={
                    order.estimatedContractBillTotalSavingsInUSDollars
                }
                hasSignedAgreement={order.hasSignedAgreement}
                payRateInUSDollars={overview.jobSalaryInUSDollars}
                contractStartDate={overview.contractStartDate}
                contractEndDate={overview.contractEndDate}
                hoursPerWeek={overview.hoursPerWeek}
            />
        </LayoutContainer>
    );
};
